export const graficosRelatoriosOperadorMethods = {
  atualizaEixoXGrafico(objetoGrafico) {
    return Object.keys(objetoGrafico)
  },

  atualizaDataAtendidas(objetoGrafico) {
    let chavesObjeto = Object.keys(objetoGrafico)
    let qtdAtendidas = []
    chavesObjeto.forEach(diaDoMes => {
      if (typeof objetoGrafico[`${diaDoMes}`].atendidas !== 'undefined') {
        qtdAtendidas.push(objetoGrafico[`${diaDoMes}`].atendidas)
      } else {
        qtdAtendidas.push(0)
      }
    })
    qtdAtendidas.splice(0, 1, qtdAtendidas[0])

    return qtdAtendidas
  },

  atualizaDataNaoAtendidas(objetoGrafico) {
    let chavesObjeto = Object.keys(objetoGrafico)
    let qtdNaoAtendidas = []
    chavesObjeto.forEach(diaDoMes => {
      if (typeof objetoGrafico[`${diaDoMes}`].naoAtendidas !== 'undefined') {
        qtdNaoAtendidas.push(objetoGrafico[`${diaDoMes}`].naoAtendidas)
      } else {
        qtdNaoAtendidas.push(0)
      }
    })
    qtdNaoAtendidas.splice(0, 1, qtdNaoAtendidas[0])

    return qtdNaoAtendidas
  },

  atualizaDataTmc(objetoGrafico) {
    let chavesObjeto = Object.keys(objetoGrafico)
    let tmc = []
    chavesObjeto.forEach(diaDoMes => {
      if (typeof objetoGrafico[`${diaDoMes}`].mediaTempoDeChamada !== 'undefined') {
        tmc.push(objetoGrafico[`${diaDoMes}`].mediaTempoDeChamada)
      } else {
        tmc.push('00:00:00')
      }
    })
    tmc.splice(0, 1, tmc[0])

    return tmc
  },

  atualizaDataTma(objetoGrafico) {
    let chavesObjeto = Object.keys(objetoGrafico)
    let tma = []
    chavesObjeto.forEach(diaDoMes => {
      if (typeof objetoGrafico[`${diaDoMes}`].mediaTempoDeAtendimento !== 'undefined') {
        tma.push(objetoGrafico[`${diaDoMes}`].mediaTempoDeAtendimento)
      } else {
        tma.push('00:00:00')
      }
    })
    tma.splice(0, 1, tma[0])

    return tma
  },

  atualizaDataTme(objetoGrafico) {
    let chavesObjeto = Object.keys(objetoGrafico)
    let tme = []
    chavesObjeto.forEach(diaDoMes => {
      if (typeof objetoGrafico[`${diaDoMes}`].mediaEspera !== 'undefined') {
        tme.push(objetoGrafico[`${diaDoMes}`].mediaEspera)
      } else {
        tme.push('00:00:00')
      }
    })

    tme.splice(0, 1, tme[0])

    return tme
  },
}
